module.exports = __webpack_public_path__ + "img/CS-Lite-Vol-Profiles.ba772cba.jpg";